import { Grid, Paper } from '@mui/material';
import React from 'react';
import { buttonStyles } from '../../../styles/buttonStyles';

const Machines = ({ coolant }) => {
  const buttonStyle = buttonStyles();
  return (
    <Grid
      container
      style={{ maxHeight: '200px', overflow: 'auto' }}
      spacing={1}
    >
      {coolant?.machines_using_coolant?.map((machine, index) => (
        <Grid item xs={6} key={`${machine}${index}`}>
          <Paper className={buttonStyle.box} variant="outlined">
            {machine}
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default Machines;
